export default "__VITE_ASSET__BrcTYrJW__"